export default __webpack_public_path__ + "static/media/Denim_Hero.d1376e08.webp";